function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "19",
  viewBox: "0 0 18 19"
}, props), React.createElement("g", {
  fill: "#057CCC",
  fillRule: "evenodd"
}, React.createElement("path", {
  fillRule: "nonzero",
  d: "M5.143 8.632a.868.868 0 100 1.736h7.714a.868.868 0 000-1.736H5.143z"
}), React.createElement("path", {
  d: "M9 .613a8.888 8.888 0 100 17.775A8.888 8.888 0 009 .613zM2.138 9.5a6.862 6.862 0 1113.725 0 6.862 6.862 0 01-13.725 0z"
}))));